<nav mat-tab-nav-bar class="navigation" [ngClass]="{ 'offers': colors === ColorSchemes.OFFERS }">
  <a
    mat-tab-link
    *ngFor="let link of links"
    [routerLink]="routerOff ? undefined : [link.path]"
    (click)="onLinkClicked(link)"
    [active]="isActive(link)"
  >
    <ng-container *ngIf="!child"> {{ link.nameKey | locCap }} </ng-container>
    <ng-container *ngIf="child">
      <ng-container
        *ngTemplateOutlet="child; context: { link: link, active: link == activeLink, default: link == defaultSelected }"
      ></ng-container>
    </ng-container>
  </a>
</nav>
